import React from 'react';
import SelectCards from '../features/cards/components/SelectCards';

const SelectCardsPage = () => {
  return <SelectCards />;
};

export default SelectCardsPage;
